// @ts-nocheck
import { EventEmitter } from '@angular/core';
import moment from 'moment';

export class MaskDateTimeBr {
	public validateEmmiter = new EventEmitter();

	private dateTimeBr: string = 'DD / MM / YYYY   [às]   HH : mm';

	public removeMask(value: string, cursorPosition): { newValue; newCursorPosition } {
		return { newValue: value, newCursorPosition: cursorPosition };
	}

	public setMask(value: any, cursorPosition): { formatedValue; formatedCursorPosition } {
		const formatedCursorPosition = cursorPosition;

		if (value) {
			if (typeof value !== 'number') {
				try {
					value = parseInt(value);
				} catch (error) {
					console.error('Date given is not a number');
				}
			}
			const formatedValue = moment(value * 1000).format(this.dateTimeBr);
			return { formatedValue, formatedCursorPosition };
		}

		return { formatedValue: value, formatedCursorPosition };
	}

	public validate(value) {
		if (moment(moment(value, this.dateTimeBr).unix()).isValid()) return true;
		return false;
	}

	public getMaskErrors() {
		return ['DATE_TIME_BR'];
	}
}
